import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { confirmMarketingUnsubscribe, verifyMarketingUnsubscribe } from '../services/adminService';

function UnsubscribePage() {
  const { token } = useParams();
  const [state, setState] = useState({
    status: 'loading',
    message: 'Checking your unsubscribe link...',
    maskedEmail: '',
  });

  useEffect(() => {
    verifyMarketingUnsubscribe(token)
      .then((data) => {
        setState({
          status: 'ready',
          message: 'Confirm that you want to unsubscribe from FactorStreet emails.',
          maskedEmail: data.maskedEmail || '',
        });
      })
      .catch(() => {
        setState({
          status: 'error',
          message: 'This unsubscribe link is invalid or expired.',
          maskedEmail: '',
        });
      });
  }, [token]);

  const confirmUnsubscribe = async () => {
    setState((current) => ({ ...current, status: 'submitting', message: 'Unsubscribing...' }));

    try {
      const data = await confirmMarketingUnsubscribe(token);
      setState({
        status: 'success',
        message: data.message || 'You have been unsubscribed from FactorStreet emails.',
        maskedEmail: data.maskedEmail || '',
      });
    } catch (error) {
      setState({
        status: 'error',
        message: 'This unsubscribe link is invalid or expired.',
        maskedEmail: '',
      });
    }
  };

  return (
    <main className="unsubscribe-page">
      <section className="unsubscribe-card">
        <p className="eyebrow">FactorStreet</p>
        <h1>{state.status === 'success' ? 'You have been unsubscribed.' : 'Unsubscribe request'}</h1>
        {state.maskedEmail && state.status !== 'success' ? <p>You are unsubscribing: {state.maskedEmail}</p> : null}
        <p>{state.message}</p>
        {state.status === 'ready' ? (
          <button className="btn btn--primary" onClick={confirmUnsubscribe} type="button">
            Confirm Unsubscribe
          </button>
        ) : null}
      </section>
    </main>
  );
}

export default UnsubscribePage;
